import { PAGE_NAME } from '../../../shared/constants';

export const CollectionsLobbyEventTypes = {
    pageView: `${PAGE_NAME}.page_view`,
    header: {
        actions: {
            createCollection: {
                clicked: `${PAGE_NAME}.header.actions.create_collection.clicked`,
            },
        },
    },
    collectionCard: {
        clicked: `${PAGE_NAME}.collection_card.clicked`,
        actions: {
            shareWithTeam: {
                clicked: `${PAGE_NAME}.collection_card.actions.share_with_team.clicked`,
            },
            socialShare: {
                clicked: `${PAGE_NAME}.collection_card.actions.social_share.clicked`,
            },
            edit: {
                clicked: `${PAGE_NAME}.collection_card.actions.edit.clicked`,
            },
            delete: {
                clicked: `${PAGE_NAME}.collection_card.actions.delete.clicked`,
            },
        },
    },
    viewFilter: {
        changed: `${PAGE_NAME}.view_filter.changed`,
    },
    emptyView: {
        actions: {
            createCollection: {
                clicked: `${PAGE_NAME}.empty_view.actions.create_collection.clicked`,
            },
        },
    },
    modals: {
        createCollection: {
            show: `${PAGE_NAME}.modals.create_collection.show`,
            cancel: `${PAGE_NAME}.modals.create_collection.cancel`,
            submit: `${PAGE_NAME}.modals.create_collection.submit`,
            fail: `${PAGE_NAME}.modals.create_collection.fail`,
        },
    },
};
